import React from 'react'
import { assets } from '../assets/assets'

const Footer = () => {
  return (
    <div className='mt-20 border-t border-gray-800'>
      <div className='flex flex-col sm:grid grid-cols-[3fr_1fr_1fr] gap-14 my-10 text-sm px-6'>

        <div>
          <img src={assets.wmlogo} className='mb-5 w-32 animate-sine' alt=""/>
          <p className='w-full md:w-2/3 text-gray-500'></p>
        </div>

        <div>
          <p className='text-center text-xl font-bold mb-5 text-white border-b border-gray-700 pb-2'>LINKS</p>
          <ul className='flex flex-col gap-2 text-white'>
            <a href='https://github.com/walkmoody' target="_blank" rel="noopener noreferrer">
              <li className='border border-gray-700 rounded-full text-center cursor-pointer bg-[#1a1a1a] font-bold hover:bg-gray-800 py-1 transition-colors'>GitHub</li>
            </a>
            <a href='https://www.linkedin.com/in/walkermoody/' target="_blank" rel="noopener noreferrer">
              <li className='border border-gray-700 rounded-full text-center cursor-pointer bg-[#1a1a1a] font-bold hover:bg-gray-800 py-1 transition-colors'>LinkedIn</li>
            </a>
          </ul>
        </div>

        <div>
          <p className='text-xl font-bold mb-5 text-white text-center border-b border-gray-700 pb-2'>GET IN TOUCH</p>
          <ul className='border border-gray-700 rounded-2xl text-center flex flex-col gap-1 text-gray-300 bg-[#1a1a1a] font-semibold px-4 py-3'>
            <li>(512)-277-0615</li>
            <li>moodywalkertx@gmail.com</li>
          </ul>
        </div>

      </div>
      <div className='flex justify-center py-4 border-t border-gray-800 px-5'>
        <p className='text-sm text-center text-gray-500'>Copyright 2025 @ Walker Moody — All Rights Reserved.</p>
      </div>
      <div className='py-5'></div>
    </div>
  )
}

export default Footer
